import { useEffect, useState } from 'react';
import { useChat } from '../../context/ChatContext';
import { useAuth } from '../../context/AuthContext';
import VideoCall from './VideoCall';
import LiveKitCall from './LiveKitCall';

const API = process.env.REACT_APP_BACKEND_URL;
let defaultModeCache = { value: null, ts: 0 };

// Picks the media engine for the active call: LiveKit SFU (server-decided per call)
// or the legacy WebRTC mesh when LiveKit is not configured / unreachable.
export default function CallSurface() {
  const chat = useChat();
  const { token } = useAuth();
  const { callId, mediaMode } = chat.callState;
  const [guess, setGuess] = useState(defaultModeCache.value);

  useEffect(() => {
    if (mediaMode || !token) return undefined;
    let cancelled = false;
    if (callId && callId !== 'pending') {
      fetch(`${API}/api/calls/${callId}`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => { if (!cancelled) chat.setMediaMode((d && d.media_mode) || 'mesh'); })
        .catch(() => { if (!cancelled) chat.setMediaMode('mesh'); });
    } else if (Date.now() - defaultModeCache.ts > 60000) {
      fetch(`${API}/api/calls/media-config`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const m = (d && d.default_mode) || 'mesh';
          defaultModeCache = { value: m, ts: Date.now() };
          if (!cancelled) setGuess(m);
        })
        .catch(() => { if (!cancelled) setGuess('mesh'); });
    }
    return () => { cancelled = true; };
  }, [callId, mediaMode, token, chat]);

  const mode = mediaMode || guess;
  if (!mode) return null;
  return mode === 'livekit' ? <LiveKitCall /> : <VideoCall />;
}
